import { Col, Row, Radio, Button, Space } from "antd"; // นำเข้า Space และ Button มาก่อนการใช้งาน
import styles from "../styles/createTemp.css";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Input } from "../../../components/form";
import SunEditor from "suneditor-react";


const CreateTemplateFromEmail = ({ showCCInput, onSubmit }) => {
    const [value, setValue] = useState(1);

    const templateShow = useSelector((state) => state.template.templateData);


    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };

    const { t } = useTranslation();
    const onBack = () => { };

    function initData() {
        return {
            ...templateShow
        }
    }
    console.log("templateShow", templateShow, initData());

    const messageValue = (name, message, setFieldValue) => {
        return (<SunEditor
            name={name}
            width="100%"
            defaultValue={message}
            setContents={message}
            onChange={(content) =>
                setFieldValue(name, content)
            }
        />
        )

    }
    return (
        <Formik enableReinitialize initialValues={templateShow} onSubmit={onSubmit}>
            {({ values, setFieldValue }) => (
                console.log("values", values, value),
                <Form className={styles.container} >
                    <Row gutter={[24, 10]}>
                        <Col span={12}>
                            <Input
                                name="subject"
                                label={t("creatTamplete.SubjectTH")}
                                placeholder={t("creatTamplete.SubjectTH")}
                                size="large"
                            />
                        </Col>
                        <Col span={12}>
                            <Input
                                name="subjectEn"
                                label={t("creatTamplete.SubjectEN")}
                                placeholder={t("creatTamplete.SubjectEN")}
                                size="large"
                            />
                        </Col>
                        <Col span={12}>
                            <Input
                                name="sendCC"
                                label={t("creatTamplete.CreateTempCC")}
                                placeholder={t('Ex.example-a-gmail-com-b-gmail-com-c-gmail-com')}
                                size="large"
                            />
                        </Col>
                        <Col span={24}>
                            <Radio.Group onChange={onChange} value={value}>
                                <Radio value={1}>{t('thai')}</Radio>
                                <Radio value={2}>{t('english')}</Radio>
                            </Radio.Group>
                        </Col>
                        <Col span={24}>
                            <p>{t("creatTamplete.Message")}</p>
                            {value == 1 && messageValue("message", values.message, setFieldValue)}
                            {value == 2 && messageValue("messageEn", values.messageEn, setFieldValue)}
                        </Col>
                    </Row>
                    <Row justify="end" style={{ paddingTop: "20px" }}>
                        <Space size={24}>
                            <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                                {t("creatTamplete.Save").toUpperCase()}
                            </Button>
                        </Space>
                    </Row>
                </Form>
            )}
        </Formik>
    );
};

export default CreateTemplateFromEmail;
